export default "__VITE_ASSET__bd7d63c7__"